export function Arrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_29841_87070)">
        <path d="M11.06 5.72656L8 8.7799L4.94 5.72656L4 6.66656L8 10.6666L12 6.66656L11.06 5.72656Z" fill="#8492C4" />
      </g>
      <defs>
        <clipPath id="clip0_29841_87070">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SuccessIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_29841_88564)">
        <circle cx="16" cy="16" r="10" fill="#54C081" />
        <path
          d="M14.75 20.2727C14.4375 20.2727 14.125 20.1515 13.875 19.9091L11.375 17.4848C10.875 17 10.875 16.2727 11.375 15.7879C11.875 15.303 12.6875 15.303 13.125 15.7879L14.75 17.3636L18.875 13.3636C19.375 12.8788 20.125 12.8788 20.625 13.3636C21.125 13.8485 21.125 14.5758 20.625 15.0606L15.625 19.9091C15.375 20.1515 15.0625 20.2727 14.75 20.2727Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_29841_88564"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.752941 0 0 0 0 0.505882 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29841_88564" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29841_88564" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export function ErrorIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_29841_88556)">
        <circle cx="16" cy="16" r="10" fill="#D3625B" />
      </g>
      <path
        d="M15.9997 16.9991C16.2649 16.9991 16.5193 16.8938 16.7068 16.7062C16.8944 16.5187 16.9997 16.2643 16.9997 15.9991L16.9997 11.9991C16.9997 11.7339 16.8944 11.4796 16.7068 11.292C16.5193 11.1045 16.2649 10.9991 15.9997 10.9991C15.7345 10.9991 15.4802 11.1045 15.2926 11.292C15.1051 11.4796 14.9997 11.7339 14.9997 11.9991L14.9997 15.9991C14.9997 16.2643 15.1051 16.5187 15.2926 16.7062C15.4802 16.8938 15.7345 16.9991 15.9997 16.9991ZM15.6197 20.9191C15.8632 21.0191 16.1363 21.0191 16.3797 20.9191C16.5025 20.8715 16.6146 20.8002 16.7097 20.7091C16.7981 20.6119 16.8691 20.5003 16.9197 20.3791C16.9757 20.2604 17.0031 20.1303 16.9997 19.9991C17.0005 19.8675 16.9753 19.7371 16.9255 19.6152C16.8757 19.4934 16.8024 19.3826 16.7097 19.2891C16.6125 19.2008 16.5009 19.1298 16.3797 19.0791C16.2282 19.0169 16.0638 18.9928 15.9008 19.009C15.7378 19.0252 15.5813 19.0812 15.445 19.1721C15.3087 19.2629 15.1969 19.3858 15.1192 19.5301C15.0416 19.6743 15.0005 19.8353 14.9997 19.9991C15.0034 20.2639 15.107 20.5175 15.2897 20.7091C15.3848 20.8002 15.497 20.8715 15.6197 20.9191Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_29841_88556"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.827451 0 0 0 0 0.384314 0 0 0 0 0.356863 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29841_88556" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29841_88556" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
